import{a}from"./chunk-TGCFYADD.js";import{m as r}from"./chunk-HBP5N4FR.js";r();function e(c){return a(c),null}export{e as a};
//# sourceMappingURL=chunk-F452YKVY.js.map
